import React from "react";
import Header from "../header/header2";
import "./info.css";
import Footer from "../footer/footer";

// Shared shell for all informational pages.
function InfoPage({ title, intro, children }) {
  return (
    <div className="info-page">
      <Header />
      <main className="info-main">
        <div className="info-hero">
          <h1 className="info-title">{title}</h1>
          {intro && <p className="info-intro">{intro}</p>}
        </div>
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default InfoPage;
